var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Thêm mới nhà cung cấp brand",
        visible: _vm.dialogVisible,
        width: "40%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "newGrade",
          attrs: {
            "label-width": "140px",
            model: _vm.newGrade,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Tên nhà cung cấp", prop: "supplierName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập tên nhà cung cấp" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.submitForm("newGrade")
                  },
                },
                model: {
                  value: _vm.newGrade.supplierName,
                  callback: function ($$v) {
                    _vm.$set(_vm.newGrade, "supplierName", $$v)
                  },
                  expression: "newGrade.supplierName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Link connect", prop: "supplierLink" } },
            [
              _c("el-input", {
                attrs: {
                  rows: 1,
                  type: "textarea",
                  autosize: "",
                  placeholder: "Nhập link connect",
                },
                model: {
                  value: _vm.newGrade.supplierLink,
                  callback: function ($$v) {
                    _vm.$set(_vm.newGrade, "supplierLink", $$v)
                  },
                  expression: "newGrade.supplierLink",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Username", prop: "usernameLink" } },
            [
              _c(
                "div",
                { staticClass: "username" },
                [
                  _c("el-input", {
                    attrs: {
                      rows: 1,
                      type: "textarea",
                      autosize: "",
                      placeholder: "Nhập username",
                    },
                    model: {
                      value: _vm.newGrade.usernameLink,
                      callback: function ($$v) {
                        _vm.$set(_vm.newGrade, "usernameLink", $$v)
                      },
                      expression: "newGrade.usernameLink",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "thanh" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Password", prop: "passwordLink" } },
                [
                  _c(
                    "div",
                    { staticClass: "password" },
                    [
                      _c("el-input", {
                        attrs: {
                          rows: 1,
                          type: "textarea",
                          autosize: "",
                          placeholder: "Nhập password",
                        },
                        model: {
                          value: _vm.newGrade.passwordLink,
                          callback: function ($$v) {
                            _vm.$set(_vm.newGrade, "passwordLink", $$v)
                          },
                          expression: "newGrade.passwordLink",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Ghi chú", prop: "supplierNote" } },
            [
              _c("el-input", {
                attrs: {
                  rows: 2,
                  type: "textarea",
                  autosize: "",
                  placeholder: "Nhập ghi chú",
                },
                model: {
                  value: _vm.newGrade.supplierNote,
                  callback: function ($$v) {
                    _vm.$set(_vm.newGrade, "supplierNote", $$v)
                  },
                  expression: "newGrade.supplierNote",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("newGrade")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "success", size: "medium", mini: "" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("newGrade")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }